module.exports = __webpack_public_path__ + "img/thirdImage.edebe31b.jpg";